"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const ColonySpace_vue_1 = require("./ColonySpace.vue");
exports.default = vue_1.default.extend({
    name: 'ColonyRow',
    components: {
        ColonySpace: ColonySpace_vue_1.default,
    },
    props: {
        metadata: {
            type: Object,
            required: true,
        },
        colony: {
            type: Object,
        },
    },
});
